import { useContext, useEffect, useState } from 'react';

import { DISPLAY_SERVER_ERROR_AT } from '../../../constants/WizardConstants';

import { ModularListingContext } from '../../../containers/CreateListingPage/context';
import { WizardContext } from '../../../components/Wizard/context';

import PageWizard from '../../../components/Wizard/PageWizard';
import WizardAlert from '../../../components/WizardAlert';

import AcceptApplicationsContentWithFields from '../../../components/WizardModularListing/AcceptZillowApplications/components/AcceptApplicationsContentWithFields';

import type { ReactNode } from 'react';
import type { ThemeConstellation } from '@zillow/constellation';
import { WizardFlexContainer } from '../../../styles/wizard';

type Props = {
  onGoToPrevStep: () => void | null;
  onGoToNextStep: () => void | null;
  onExitWizard: (...args: Array<unknown>) => void;
  wizardTitle: ReactNode;
  progressStepper: ReactNode;
  totalSteps: number;
  currentStepIndex: number;
  showDesktopViewBreakpoint: keyof (typeof ThemeConstellation)['constellation']['breakpoints'];
};

const AcceptZillowApplications = ({
  onGoToNextStep,
  onGoToPrevStep,
  onExitWizard,
  wizardTitle,
  progressStepper,
  totalSteps,
  currentStepIndex,
  showDesktopViewBreakpoint,
  ...rest
}: Props) => {
  const {
    // @ts-expect-error WizardContext
    wizardState: { isFetchingData },
  } = useContext(WizardContext);

  const {
    modularListingState: { serverErrorObj },
  } = useContext(ModularListingContext);

  const [clickedNext, setClickedNext] = useState(false);
  const [clickedBackNext, setClickedBack] = useState(false);

  useEffect(() => {
    const { fieldName } = serverErrorObj;

    if (!fieldName && !isFetchingData) {
      checkNavToStep();
    }
  }, [isFetchingData]);

  const checkNavToStep = () => {
    if (clickedNext) {
      onNextClick();
    }

    if (clickedBackNext) {
      onBackClick();
    }
  };

  const onNextClick = () => {
    if (isFetchingData) {
      setClickedNext(true);
      return;
    }

    onGoToNextStep();
  };

  const onBackClick = () => {
    if (isFetchingData) {
      setClickedBack(true);
      return;
    }

    onGoToPrevStep();
  };

  return (
    <PageWizard
      title=""
      wizardTitle={wizardTitle}
      progressStepper={progressStepper}
      totalSteps={totalSteps}
      currentStepIndex={currentStepIndex}
      onNextClick={onNextClick}
      onBackClick={onBackClick}
      onExitTriggered={onExitWizard}
      showDesktopViewBreakpoint={showDesktopViewBreakpoint as unknown as string}
      {...rest}
    >
      <div data-testid="AcceptZillowApplications">
        <WizardAlert serverErrorObj={serverErrorObj} displayAt={DISPLAY_SERVER_ERROR_AT.PAGE} />

        <WizardFlexContainer>
          <AcceptApplicationsContentWithFields />
        </WizardFlexContainer>
      </div>
    </PageWizard>
  );
};

export default AcceptZillowApplications;
